export default "__VITE_ASSET__Dcq3_2WK__"